import { createReducer } from 'helpers/store/createReducer';
import { combineReducers } from 'redux';
import { fetchOrderType, fetchOrderTypes, updateOrderType } from './actions';

const initState = {
  orderType: {
    orderType: null,
    isLoading: true,
  },
  orderTypes: {
    orderTypes: [],
    isLoading: false,
  },
};

const orderTypes = createReducer(initState, {
  [fetchOrderType]: state => ({
    ...state,
    orderType: {
      ...state.orderType,
      isLoading: true,
    },
  }),
  [fetchOrderType.success]: (state, action) => ({
    ...state,
    orderType: {
      // ...state.orderType,
      orderType: {
        ...action.payload,
        isLoading: false,
      },
    },
  }),
  [fetchOrderType.failure]: (state, action) => ({
    ...state,
    orderType: {
      ...state.orderType,
      error: action.payload,
      isLoading: false,
    },
  }),

  [fetchOrderTypes]: state => ({
    ...state,
    orderTypes: {
      ...state.orderTypes,
      isLoading: true,
    },
  }),
  [fetchOrderTypes.success]: (state, action) => ({
    ...state,
    orderTypes: {
      ...state.orderTypes,
      orderTypes: action.payload.results,
      isLoading: false,
    },
  }),
  [fetchOrderTypes.failure]: (state, action) => ({
    ...state,
    orderTypes: {
      ...state.orderTypes,
      error: action.payload,
      isLoading: false,
    },
  }),

  [updateOrderType]: state => ({
    ...state,
    orderType: {
      isLoading: true,
    },
  }),
  [updateOrderType.success]: (state, action) => ({
    ...state,
    orderType: {
      orderType: {
        ...action.payload,
        isLoading: false,
      },
    },
  }),
  [updateOrderType.failure]: state => ({
    ...state,
    orderType: {
      // ...action.payload,
      isLoading: false,
    },
  }),
});

export default combineReducers({
  orderTypes,
});
